﻿import React from 'react';
import {Grid, GridProps} from "@mui/material";

type CardRowItemContainerProps = GridProps

/**
 * MUI Grid component styled in the SecurSpace way. Used inside a RowContainer to hold and style subsequent item/value pairs
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CardRowItemContainer = ({ children, ...rest}: CardRowItemContainerProps) => {
  return <Grid item xs={12} sm={6} md={3} {...rest}>
    { children }
  </Grid>
}

export { CardRowItemContainer };
